module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-KICKSTARTER.d4176fce.png";